export default "__VITE_ASSET__CeaO4gdr__"